import React, { Component, PropTypes } from 'react';
import { routerShape } from 'react-router/lib/PropTypes';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { autobind } from 'core-decorators';

import { users } from 'actions';
import { byIdShape } from 'utils/propTypes';

import PageHeader from 'AppComponents/PageHeader';

import User from './User';
import SortableHeader from './SortableHeader';

import './styles.scss';


const sortUsers = (usersById, sortBy, desc = true) => {
  const all = Object.keys(usersById).filter((pk) => {
    const user = usersById[pk];
    return user.num_charger_reviews > 0 || user.num_place_reviews > 0;
  });
  return all.sort((a, b) => {
    const aUser = usersById[a] || {};
    const bUser = usersById[b] || {};
    if (aUser[sortBy] > bUser[sortBy]) return desc ? -1 : 1;
    if (aUser[sortBy] < bUser[sortBy]) return desc ? 1 : -1;
    return 0;
  });
};


class UserRankings extends Component {

  static propTypes = {
    usersById: byIdShape.isRequired,
    usersRequest: PropTypes.func.isRequired,
  };

  static contextTypes = {
    router: routerShape.isRequired,
  };

  static childContextTypes = {
    sortBy: PropTypes.string,
    sortDesc: PropTypes.bool,
  };

  constructor(props, context) {
    super(props, context);
    const defaultSort = 'num_chargers_visited';
    this.state = {
      sorted: (
        props.usersById && Object.keys(props.usersById).length > 0 ?
        sortUsers(props.usersById, defaultSort, true) : []
      ),
      sortBy: defaultSort,
      sortDesc: true,
    };
  }

  getChildContext() {
    return {
      sortBy: this.state.sortBy,
      sortDesc: this.state.sortDesc,
    };
  }

  componentDidMount() {
    this.props.usersRequest({
      averages: true,
      exclude_consumers: true,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      sorted: sortUsers(nextProps.usersById, this.state.sortBy, this.state.sortDesc),
    });
  }

  @autobind
  handleSortClick(param, desc) {
    if (param !== this.state.sortBy || desc !== this.state.sortDesc) {
      this.setState({
        sorted: sortUsers(this.props.usersById, param, desc),
        sortBy: param,
        sortDesc: desc,
      });
    }
  }

  render() {
    const { usersById } = this.props;
    const { sorted } = this.state;
    return (
      <div className='container' styleName='user-rankings'>

        <Helmet title='User Rankings' />

        <PageHeader title='User Rankings' />

        <table className='table table-hover rankings-list'>

          <thead>

            <tr>
              <th className='name' colSpan={2} />
              <th className='charger' colSpan={3}>Chargers</th>
              <th className='place' colSpan={3}>Places</th>
            </tr>

            <tr>

              <SortableHeader
                sortParam='public_name'
                onSort={this.handleSortClick}
                className='name'
                colSpan={2}
              >
                User
              </SortableHeader>

              <SortableHeader
                sortParam='num_chargers_visited'
                onSort={this.handleSortClick}
              >
                Visited
              </SortableHeader>

              <SortableHeader
                sortParam='num_charger_reviews'
                onSort={this.handleSortClick}
              >
                Reviews
              </SortableHeader>

              <SortableHeader
                sortParam='charger_average_rating'
                onSort={this.handleSortClick}
              >
                Average Rating
              </SortableHeader>

              <SortableHeader
                sortParam='num_place_reviews'
                onSort={this.handleSortClick}
              >
                Reviews
              </SortableHeader>

              <SortableHeader
                sortParam='place_average_rating'
                onSort={this.handleSortClick}
              >
                Average Rating
              </SortableHeader>

              <SortableHeader
                sortParam='place_average_walkability_rating'
                onSort={this.handleSortClick}
              >
                Average Walkability Rating
              </SortableHeader>

            </tr>

          </thead>

          <tbody>
            { sorted ? sorted.map((pk) => {
              const user = usersById[pk];
              return (
                <User
                  key={user.pk}
                  user={user}
                  onClick={() => this.context.router.push(`/user/${user.username}/`)}
                />
              );
            }) : null }
          </tbody>

        </table>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  usersById: state.users.byId,
});

const usersRequest = users.request;

export default connect(
  mapStateToProps, {
    usersRequest,
  })(UserRankings);



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/UserRankings/index.jsx